const MIN_BOTTOM_COVERAGE = 1;
const BOTTOM_COVERAGE_TOLERANCE = 0.001;

export const getFaceFraming = (metadata) => {
  if (!metadata || typeof metadata !== "object") {
    return null;
  }

  const faceCenterX = Number(metadata.faceCenterX);
  const eyeLineY = Number(metadata.eyeLineY);
  const recommendedScale = Number(metadata.recommendedScale);
  const targetEyeLine = Number(metadata.targetEyeLine ?? 0.30);
  if (![faceCenterX, eyeLineY, recommendedScale, targetEyeLine].every(Number.isFinite)) {
    return null;
  }
  if (faceCenterX < 0 || faceCenterX > 1 || eyeLineY < 0 || eyeLineY > 1 || recommendedScale < 0.75) {
    return null;
  }

  const scale = Math.min(recommendedScale, 2.2);
  const target = Math.min(Math.max(targetEyeLine, 0.20), 0.40);

  // The frame and its image are bottom-aligned. After scaling around the eye
  // line and translating the eyes to their target, this is the image bottom's
  // normalized Y coordinate. Reject framing that would lift it above the
  // frame's bottom and expose empty space.
  const transformedBottom = target + (scale * (1 - eyeLineY));
  if (transformedBottom < MIN_BOTTOM_COVERAGE - BOTTOM_COVERAGE_TOLERANCE) {
    return null;
  }

  return {
    faceCenterX,
    eyeLineY,
    recommendedScale: scale,
    targetEyeLine: target,
  };
};
